(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["how-to-measure"] && !Shopify.designMode) return;
  try {
    function htmRelocateTrigger(trigger) {
    // Try to move the trigger next to the "Size" option's label, so it reads
    // like "SIZE  ·  SIZE CHART" on one row (matches ersanails.com layout),
    // instead of sitting as its own row below the whole variant picker.
    if (!trigger || trigger.dataset.htmRelocated === 'true') return;

    var candidates = document.querySelectorAll(
      '.variant-option--dropdowns, .variant-option--buttons, .variant-option--swatches'
    );

    for (var i = 0; i < candidates.length; i++) {
      var optionRow = candidates[i];
      var labelEl = optionRow.querySelector('label, legend');
      if (!labelEl) continue;

      var labelText = (labelEl.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      // Match "Size" as a whole word so it doesn't accidentally match
      // something like "Sized" or a swatch value string.
      if (labelText === 'size' || labelText.indexOf('size ') === 0) {
        optionRow.classList.add('htm-size-option');
        labelEl.insertAdjacentElement('afterend', trigger);
        trigger.dataset.htmRelocated = 'true';
        return;
      }
    }
    // No matching "Size" option found on this page (e.g. option renamed) —
    // trigger just stays in its original default position below the block.
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.htm-block').forEach(function (block) {
      var trigger = block.querySelector('.htm-trigger-row');
      var overlay = block.querySelector('.htm-overlay');
      var panel = block.querySelector('.htm-panel');
      var closeBtn = block.querySelector('.htm-close');
      if (!trigger || !overlay || !panel || !closeBtn) return;

      htmRelocateTrigger(trigger);

      function openPanel() {
        overlay.classList.add('is-active');
        panel.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }
      function closePanel() {
        overlay.classList.remove('is-active');
        panel.classList.remove('is-active');
        document.body.style.overflow = '';
      }

      trigger.addEventListener('click', openPanel);
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openPanel();
        }
      });
      closeBtn.addEventListener('click', closePanel);
      overlay.addEventListener('click', closePanel);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
